'use client';

import { c as _c } from "react/compiler-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePreviewMode } from '@/hooks/use-preview-mode';
import type { Locale, StaticTranslationString } from '@/types/types';
import { i18nConfig } from '@/types/types';
import { useCurrentLocale } from 'next-i18n-router/client';
import React from 'react';
const enableString: StaticTranslationString = {
  de: 'Aktiviert',
  en: 'Enabled',
  fr: 'Activé'
};
const disabledString: StaticTranslationString = {
  de: 'Deaktiviert',
  en: 'Disabled',
  fr: 'Désactivé'
};

/**
 * Handles the change of the preview mode and updates the URL accordingly.
 */
/**
 * Handles the change of the preview mode and updates the URL accordingly.
 * Now uses the `usePreviewMode` custom hook for logic encapsulation.
 */
export const PreviewModeToggle: React.FC = () => {
  const $ = _c(12);
  const locale = useCurrentLocale(i18nConfig) as Locale;
  const {
    isInPreviewMode,
    togglePreviewMode
  } = usePreviewMode();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SelectTrigger className="flex h-7 items-center border-none bg-gray-900 px-2 text-xs text-gray-100"><SelectValue /></SelectTrigger>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = enableString[locale];
  let t2;
  if ($[1] !== t1) {
    t2 = <SelectItem className="text-xs" value="enabled">{t1}</SelectItem>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = disabledString[locale];
  let t4;
  if ($[3] !== t3) {
    t4 = <SelectItem className="text-xs" value="disabled">{t3}</SelectItem>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <SelectContent className="z-[250] bg-gray-900 p-2 text-gray-100">{t2}{t4}</SelectContent>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isInPreviewMode || $[9] !== t5 || $[10] !== togglePreviewMode) {
    t6 = <Select defaultValue={isInPreviewMode} onValueChange={togglePreviewMode}>{t0}{t5}</Select>;
    $[8] = isInPreviewMode;
    $[9] = t5;
    $[10] = togglePreviewMode;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};